import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import Checkbox from "../../../../Core/Fields/Floating/Checkbox";
import Button from "../../../../Core/Button/Button.jsx";
import Textarea from "../../../../Core/Fields/Floating/Textarea.jsx";
const Tab1 = ({
  pageState,
  handleChange,
  onInputChange,
  invoiceList,
  userList,
  CompanyList,
  errors,
  setselected_item_data,

  CostCenterList,
  list_data,
}) => {
  const statusList = [
    { name: "Passive" },
    { name: "Open" },
    { name: "Replied" },
  ];
  const getToday = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <div>
      <div className="px-3 pb-2 pt-4" style={{ background: "white" }}>
        <div className="mb-3" style={{ display: "flex", gap: "20px" }}>
          <div className="col-md-12" style={{ display: "flex" }}>
            <div className="col-md-6 px-2">
              <div
                className=""
                style={{
                  backgroundColor: "#EBE6FA",
                  // height: "100%",
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                  // width: "100%",
                  padding: "10px",
                }}
              >
                <div class="row mb-2">
                  <div class="col-md-3">
                    <div class="text-muted small">Series</div>
                    <div class="fw-semibold">CF-(abbr)-#####</div>
                  </div>

                  <div class="col-md-3">
                    <div class="text-muted small">Customer</div>
                    <div
                      class="fw-semibold text-danger"
                      style={{ color: "#5D1A40" }}
                    >
                      Muskan Khan
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="text-muted small">Contact No</div>
                    <div
                      class="fw-semibold text-danger"
                      style={{ color: "#5D1A40" }}
                    >
                      0987654321
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="text-muted small">Date of Visit</div>
                    <div class="fw-semibold">27-06-2025</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3">
                    <div class="text-muted small">Pass ID (Welcome Form)</div>
                    <div
                      class="fw-semibold text-danger"
                      style={{ color: "#5D1A40" }}
                    >
                      WL-LND-00004
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="text-muted small">Customer Type</div>
                    <div class="fw-semibold" style={{ color: "#2C2B31" }}>
                      OLD Customer (CRR)
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="text-muted small">Company</div>
                    <div class="fw-semibold " style={{ color: "#B38235" }}>
                      Lakshmi Narain Diamond (India) Pvt. Ltd.
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="mb-3 p-3 mt-3 rounded"
                style={{ backgroundColor: "#FEFAF4" }}
              >
                <div class="fw-semibold mb-2">Heard About Us From</div>

                <div class="d-flex flex-wrap gap-4">
                  <div class="form-check">
                    <Checkbox id="forbuying" label="   Owner's Reference" />
                  </div>

                  <div class="form-check">
                    <Checkbox
                      id="forbuying"
                      label="   Old Customer Reference"
                    />
                  </div>

                  <div class="form-check">
                    <Checkbox id="forbuying" label="    Walk in" />
                  </div>

                  <div class="form-check">
                    <Checkbox id="forbuying" label="  Instagram" />
                  </div>

                  <div class="form-check">
                    <Checkbox id="forbuying" label="Website" />
                  </div>
                </div>
              </div>
              <div class="p-3 rounded mb-3" style={{backgroundcolor:"#ECEFF9"}}>
                <div class="fw-semibold mb-3">Feedback Form</div>

                <div class="row g-4">
                  <div class="col-md-3 col-6">
                    <div class="small mb-1">Design Rating</div>
                    <span class="text-warning fs-5">★ ★ ★</span>
                    <span class="text-secondary fs-5">★ ★</span>
                  </div>

                  <div class="col-md-3 col-6">
                    <div class="small mb-1">Overall Rating</div>
                    <span class="text-secondary fs-5">★ ★ ★ ★ ★</span>
                  </div>

                  <div class="col-md-3 col-6">
                    <div class="small mb-1">Service Rating</div>
                    <span class="text-warning fs-5">★ ★ ★ ★</span>
                    <span class="text-secondary fs-5">★</span>
                  </div>

                  <div class="col-md-3 col-6">
                    <div class="small mb-1">Ambience Rating</div>
                    <span class="text-secondary fs-5">★ ★ ★ ★ ★</span>
                  </div>

                  <div class="col-md-3 col-6">
                    <div class="small mb-1">Quality Rating</div>
                    <span class="text-secondary fs-5">★ ★ ★ ★ ★</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 px-2">
              <div
                style={{
                  backgroundColor: "#E3F5DF",
                
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                
                  padding: "10px",
                  gap: "15px",
                }}
              >
                {/* Row 1 */}

                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="from_currency"
                      label="Email ID "
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <Input
                      id="from_currency"
                      type="date"
                      label="Birthday"
                      style={{
                        height: "30px",
                      }}
                      value={getToday()}
                    />
                  </div>
                </div>

                {/* Row 2 */}
                <div style={{ display: "flex", gap: "15px" }}>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="from_currency"
                      type="date"
                      label="Anniversary"
                      style={{
                        height: "30px",
                      }}
                      value={getToday()}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="from_currency"
                      label="Spouse Name "
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <Input
                      id="from_currency"
                      type="date"
                      label="Spouse Birthday"
                      style={{
                        height: "30px",
                      }}
                      value={getToday()}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", gap: "15px", width: "50%" }}>
                  <div style={{ flex: 1 }}>
                    <Textarea
                      label="Address"
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>
                </div>
              </div>
                <div className="mt-3"
                style={{
                  backgroundColor: "#ECEFF9",
                
                  borderRadius: "4px",
                  display: "flex",
                  flexDirection: "column",
                
                  padding: "10px",
                  gap: "15px",
                }}>
                    <div style={{ display: "flex", gap: "15px", width: "50%" }}>
                  <div style={{ flex: 1 }}>
                    <Textarea
                      label="Remarks"
                      style={{
                        height: "30px",
                      }}
                    />
                  </div>
                </div>

                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab1;
